// svc-auth revokes the whole session, in every tab, if a rotated-out refresh
// token is replayed, and every tab renews against one shared localStorage
// session. See docs/core/auth/agent-hub-oidc-session-renewal.md.
export const renewLockName = (clientId: string): string => `oidc:refresh:${clientId}`

export function withRenewLock<T>(clientId: string, run: () => Promise<T>): Promise<T> {
  // No Web Locks (needs a secure context): unserialised, so the caller's
  // re-check inside `run` is the only remaining guard.
  if (typeof navigator === 'undefined' || !navigator.locks) {
    return run()
  }

  return navigator.locks.request(renewLockName(clientId), { mode: 'exclusive' }, run) as Promise<T>
}
